import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import {Route, Navigate} from 'react-router-dom';

export default [
  <Route key="/business/showcase/face-analyzer" element={<ShowocaseLayout />}>
    <Route path="business/showcase/face-analyzer" element={<AsyncPage />} />
  </Route>,
  <Route
    key="/business/showcase/face-analyzer/:type(attributes)?"
    path="business/showcase/face-analyzer/attributes"
    element={
      <Navigate
        to="../business/showcase/face-analyzer?type=attributes"
        replace
      />
    }
  />,
];
